import { Turbo } from '@hotwired/turbo-rails';
import '@/js/turbo/extensions';

Turbo.session.drive = false;
